export const SET_COMPACT = 'MENU::SET_COMPACT';

export type State = {
    compact: boolean;
}

export type CompactAction = {
    type: typeof SET_COMPACT;
    payload: boolean;
}
